export const CALENDLY_URL = 'https://calendly.com/modifi-demo/demo-15-min'
export const cookieSettingsPath = '#cookie-setting'
export const PLUGIN_NAME = 'website-client'
export const PRIVACY_POLICY_URL = '/privacy-policy'
